import { useEffect } from "react";
import { CommonType, ParserConfigDto } from "../../../types";
import { updateParserConfig } from "../../../services/parserConfigService";
import { getConnectionTypeList } from "../../../services/connectionTypeService";
import { getPayloadTypeList } from "../../../services/payloadTypeService";
import { useParserConfigFormState } from "./useParserConfigFormState";

export const useParserConfigUpdate = (
  open: boolean,
  parserConfig: ParserConfigDto | undefined,
  deviceTypeId: number
) => {
  const form = useParserConfigFormState();

  useEffect(() => {
    if (!open || !parserConfig) return;

    form.setParserName(parserConfig.parserName);
    form.setDescription(parserConfig.description ?? "");

    const loadTypes = async () => {
      const [connTypeRes, payloadTypeRes] = await Promise.all([
        getConnectionTypeList(),
        getPayloadTypeList(),
      ]);

      if (connTypeRes.data.success) {
        const configs: CommonType[] = connTypeRes.data.data;
        form.setConnectionTypes(configs);
        form.setSelectedConnectionType(configs.find(c => c.id === parserConfig.connectionTypeId) ?? null);
      }

      if (payloadTypeRes.data.success) {
        const types: CommonType[] = payloadTypeRes.data.data;
        form.setPayloadTypes(types);
        form.setSelectedPayloadType(types.find(t => t.id === parserConfig.payloadTypeId) ?? null);
      }
    };

    loadTypes().catch(console.error);
  }, [open, parserConfig]);

  const handleUpdate = async () => {
    const { parserName, selectedConnectionType, selectedPayloadType, description } = form;
    if (!parserName || !selectedConnectionType || !selectedPayloadType) {
      throw new Error("Lütfen tüm alanları doldurun");
    }

    const response = await updateParserConfig({
      id: parserConfig?.id,
      parserName,
      description,
      connectionTypeId: selectedConnectionType.id,
      payloadTypeId: selectedPayloadType.id,
      ...(deviceTypeId !== undefined && { deviceTypeId }),
    });

    if (!response.data.success) throw new Error(response.data.message);
    return response.data.message;
  };

  return { ...form, handleUpdate };
};
